'use client'

import { Session } from 'next-auth'
import { getCsrfToken, signIn, signOut } from 'next-auth/react'
import { useEffect } from 'react'

interface RegistrationRedirectProps {
  registrationCode: string
  session: Session | null
}

export default function RegistrationRedirect({
  registrationCode,
  session,
}: RegistrationRedirectProps) {
  useEffect(() => {
    const startRegistration = async () => {
      const csrfToken = await getCsrfToken()

      if (session) {
        await signOut({ redirect: false })
      }

      await signIn(
        'azure-ad-b2c-onboarding',
        {
          callbackUrl: '/',
          redirect: true,
          csrfToken,
        },
        { registrationCode },
      )
    }

    startRegistration()
  }, [registrationCode, session])

  return null
}
